import { render, staticRenderFns } from "./ControleDocumentosGenericoView.vue?vue&type=template&id=75e3b34f"
import script from "./ControleDocumentosGenericoView.vue?vue&type=script&lang=js"
export * from "./ControleDocumentosGenericoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports